import { IPublicClientApplication } from '@azure/msal-browser'

export type GetTokenOptions = {
  readonly forceRefresh?: boolean
}

export type TokenProvider = {
  readonly getToken: (options?: GetTokenOptions) => Promise<string>
}

export function createTokenProvider(msal: IPublicClientApplication, scopes: string[]): TokenProvider {
  let pendingRefresh: Promise<string> | null = null

  async function acquire(forceRefresh: boolean): Promise<string> {
    const account = msal.getActiveAccount() ?? msal.getAllAccounts()[0]
    // 'no_logged' is the message matchAuthenticationErrors already routes to loginRedirect.
    if (!account) throw new Error('no_logged')

    const response = await msal.acquireTokenSilent({ scopes, account, forceRefresh })
    return response.idToken
  }

  function getToken(options: GetTokenOptions = {}): Promise<string> {
    if (!options.forceRefresh) return acquire(false)

    // A burst of expired requests must trigger a single refresh, not one per request.
    if (!pendingRefresh) {
      pendingRefresh = acquire(true).finally(() => {
        pendingRefresh = null
      })
    }
    return pendingRefresh
  }

  return { getToken }
}
